"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _block = require("../block");
var _headingLevel = require("./heading-level");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
const FONTS = ['', 'font1050', 'font950', 'font850', 'font750', 'font650', 'font550'];
const Heading = ({
  styleLevel,
  ...restProps
}) => /*#__PURE__*/React.createElement(_headingLevel.LevelContext.Consumer, null, level => {
  if (level === 0) {
    throw new Error('Heading component must be a descendant of HeadingLevel component.');
  }
  if (level > 6) {
    throw new Error(`HeadingLevel cannot be nested ${level} times. The maximum is 6 levels.`);
  }
  if (typeof styleLevel !== 'undefined' && (styleLevel < 1 || styleLevel > 6)) {
    throw new Error(`styleLevel = ${styleLevel} is out of 1-6 range.`);
  }
  return /*#__PURE__*/React.createElement(_block.Block, _extends({
    "data-baseweb": "heading",
    as: `h${level}`,
    font: styleLevel ? FONTS[styleLevel] : FONTS[level],
    color: "contentPrimary"
  }, restProps));
});
var _default = exports.default = Heading;